import { render } from "./Passageiro.vue?vue&type=template&id=31235d65"
import script from "./Passageiro.vue?vue&type=script&lang=js"
export * from "./Passageiro.vue?vue&type=script&lang=js"

import "../css/transporte.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__